/**
 * Input snippet enhancements.
 *
 * Degrades gracefully: without this JS the password field stays masked
 * (still usable), the textarea stays at its min-height (still usable),
 * and the character counter shows its initial count (static).
 *
 * Loaded as a module so the browser dedupes it across multiple snippet
 * renders on the same page.
 */

(function () {
  'use strict';

  const init = () => {
    const wrappers = document.querySelectorAll('[data-input-wrapper]:not([data-input-init])');
    wrappers.forEach(setupWrapper);
  };

  const setupWrapper = (wrapper) => {
    wrapper.setAttribute('data-input-init', '');

    const passwordToggle = wrapper.querySelector('[data-password-toggle]');
    if (passwordToggle) setupPasswordToggle(wrapper, passwordToggle);

    const textarea = wrapper.querySelector('[data-auto-expand]');
    if (textarea) setupTextarea(wrapper, textarea);
  };

  const setupPasswordToggle = (wrapper, button) => {
    const input = wrapper.querySelector('input');
    const iconShow = button.querySelector('[data-password-icon-show]');
    const iconHide = button.querySelector('[data-password-icon-hide]');
    if (!input || !iconShow || !iconHide) return;

    button.addEventListener('click', () => {
      const reveal = input.type === 'password';
      input.type = reveal ? 'text' : 'password';
      button.setAttribute('aria-label', reveal ? 'Hide password' : 'Show password');
      iconShow.classList.toggle('hidden', reveal);
      iconHide.classList.toggle('hidden', !reveal);
    });
  };

  const setupTextarea = (wrapper, textarea) => {
    const counterEl = wrapper.querySelector('[data-char-counter] [data-char-count]');

    const resize = () => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    };

    const updateCount = () => {
      if (counterEl) counterEl.textContent = textarea.value.length;
    };

    textarea.addEventListener('input', () => {
      resize();
      updateCount();
    });

    // Initial pass so pre-populated values size and count correctly.
    resize();
    updateCount();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
